import { erpApi } from "@/shared/axios";
import { ROUTER_PATHS, urlBackend } from "@/shared/constants";
import { AlertSeverityEnum,UseMutationsParams } from "@/shared/interfaces";
import { IFactibilidadCorporativo, IFactibilidadCorporativoParams, IFactibilidadCorporativoResp } from "@/shared/interfaces/erp/factibilidad_corporativo";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { get, post, put } = erpApi()


///* Obtener factibilidad corporativos
export const useFetchGetfactibilidadCorporativos = (
  params: IFactibilidadCorporativoParams, enabled: boolean = true
) => {

  return useQuery({
    queryKey: ['factibilidadcoorporativa', ...Object.values(params || {})],
    queryFn: async () => {
      return await getfactibilidadCorporativos(params ?? {})
    },
    refetchOnWindowFocus: false,
    enabled
  })
}

export const getfactibilidadCorporativos = async (data: IFactibilidadCorporativoParams) => {
  const queryParams = getUrlParamsFetch(data || {})
  return await get<IFactibilidadCorporativoResp>(`${urlBackend}api/v1/factibilidadcoorporativa/?${queryParams}&backup_group_order=true`,
    true
  );
}


///* Buscar factibilidad corporativa por id

export const useFetchGetByIdfactibilidadCorporativos = (
  id: string
) => {
  return useQuery({
    queryKey: ['factibilidadcoorporativa', id],
    queryFn: async () => {
      return await getByIdFactibilidadCorporativos(id)
    },
    refetchOnWindowFocus: false,
    gcTime: 0,

  })
}

export const getByIdFactibilidadCorporativos = async (id: string) => {
  return await get<IFactibilidadCorporativo>(`${urlBackend}api/v1/factibilidadcoorporativa/${id}/`, true);
}


///* Crear una factibilidad corporativa
export const useFetchPostFactibilidadCorporativo = (
  {
    enableSuccessAlert,
    navigate
  }: UseMutationsParams
) => {

  const queryClient = useQueryClient();

  const setAlert = useUiStore(s => s.setAlert);
  return useMutation({
    mutationFn: postFactibilidadCorporativo,
    onSuccess: (data) => {

      queryClient.invalidateQueries({ queryKey: ['factibilidadcoorporativa'] })

      enableSuccessAlert
        && setAlert(true, data.message, AlertSeverityEnum.success)

      navigate && navigate(ROUTER_PATHS.noc.factibilidadCorporativoNav)
    },
    onError: (error) => handleAxiosError(error)
  })
}

export const postFactibilidadCorporativo = async (data: IFactibilidadCorporativoParams) => {
  return await post<IFactibilidadCorporativo>(`${urlBackend}api/v1/factibilidadcoorporativa/`, data, true)
}

///* Actualizar una factibilidad corporativa
export const useFetchPutFactibilidadCorporativo = (
  {
    enableSuccessAlert,
    navigate,
    returnUrl,
    inSiteRefresh = false
  }: UseMutationsParams
) => {

  const queryClient = useQueryClient();
  const setAlert = useUiStore(s => s.setAlert);
  return useMutation({
    mutationFn: putFactibilidadCorporativo,
    onSuccess: (data) => {
      inSiteRefresh?
      queryClient.invalidateQueries({ queryKey: ['factibilidadcoorporativa'] })
      : queryClient.invalidateQueries({ queryKey: ['factibilidadcoorporativa', data.data.id_factibilidad_coorporativa] })


      enableSuccessAlert
        && setAlert(true, data.message, AlertSeverityEnum.success)

      navigate && returnUrl && navigate(returnUrl)
    },
    onError: (error) => handleAxiosError(error)
  })
}

export const putFactibilidadCorporativo = async (data: IFactibilidadCorporativoParams) => {
  return await put<IFactibilidadCorporativo>(`${urlBackend}api/v1/factibilidadcoorporativa/${data.id_factibilidad_coorporativa}/`, data, true)
}

